import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Dropdown } from "primereact/dropdown";
import { RiArrowDownSFill } from "react-icons/ri";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { CopyToClipboard } from "react-copy-to-clipboard";
import axios from "axios";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { SelectButton } from "primereact/selectbutton";
import { validateEmail } from "../../Login/utils";
import { InputTextarea } from "primereact/inputtextarea";
import { TabView, TabPanel } from "primereact/tabview";
import { Checkbox } from "primereact/checkbox";
import { Card } from "primereact/card";
import {
  setUserSessionAuthKey,
  previewPdf
} from "../../../Component/commonUtils";
import { OverlayPanel } from "primereact/overlaypanel";
import { RadioButton } from "primereact/radiobutton";
import "./SRUDashboard.css";
import Sidebar from "../SRUSidebar/SRUSidebar";
import ScrolltoTop from "../../ScrollTop/ScrollTop";
import Footer_contact_tab from "../../Footerpage/Footer_contact_tab";
import SRUNavBarHeader from "../SRUNavBarHeader/SRUNavBarHeader";
import TranslationFile from "../../15-Translation/locale/Translation_apps.json";
import config from "../../../Configuration/Config";

let uuid = "/year";
let accRegNo = "",
  transformedArray = [];
let userSelectedLanguage;
let unPaidReportsArray = [];

let sessionUUIDFromLS = localStorage.getItem("sessionUUID");
let currentUser = localStorage.getItem("rebelSkoolUser");
if (currentUser) {
  currentUser = JSON.parse(localStorage.getItem("rebelSkoolUser"));
}
const userGUID =
  currentUser && currentUser.userGUID
    ? currentUser.userGUID
    : sessionUUIDFromLS;

export default function SRUDashboard() {
  userSelectedLanguage = localStorage.getItem("selectedLanguage");
  let userTimeZone = localStorage.getItem("userTimeZone");

  const history = useHistory();
  let isValidEmailIDCheck = false;
  let emptyProduct = {
    id: null,
    companyName: "",
    organizationNumber: "",
    financialYear: "",
    linkSharing: "",
    accountingCompanySharing: "",
    createdOn: "",
    createdBy: "",
    modifiedOn: "",
    modifiedBy: "",
    reportStatus: ""
  };
  let userSessionAuthKeyReturnValue = setUserSessionAuthKey();

  const getSeverityActive = (Active) => {
    switch (Active) {
      case "Read Only":
      case "Kan läsa":
        return "warning";

      case "Can Edit":
      case "Kan ändra":
        return "success";

      case "No Access":
      case "Ingen åtkomst":
        return "danger";
    }
  };

  const getAccessLevelTextInSw = (Active) => {
    switch (Active) {
      case "Read Only":
        return "Kan läsa";

      case "Can Edit":
        return "Kan ändra";

      case "No Access":
        return "Ingen åtkomst";

      // case "Kan läsa":
      //   return "Read Only";

      // case "Kan ändra":
      //   return "Can Edit";

      // case "Ingen åtkomst":
      //   return "No Access";
    }
  };

  const getAccessLevelTextInEn = (Active) => {
    switch (Active) {
      case "Kan läsa":
        return "Read Only";

      case "Kan ändra":
        return "Can Edit";

      case "Ingen åtkomst":
        return "No Access";
    }
  };

  const shareAccess = [
    {
      label: TranslationFile.dashboardLinkShareRead[userSelectedLanguage],
      code: "Read Only",
      name: "Read Only"
    },
    {
      label: TranslationFile.dashboardLinkShareWrite[userSelectedLanguage],
      code: "Can Edit",
      name: "Can Edit"
    },
    {
      label: TranslationFile.dashboardLinkShareNoAccess[userSelectedLanguage],
      code: "No Access",
      name: "No Access"
    }
  ];

  const peopleWithAccess = [
    { name: "Read Only", code: "Read Only" },
    { name: "Write", code: "Write" },
    { name: "Remove Access", code: "Write" }
  ];

  const [shareEmail, setShareEmail] = useState(null);
  const [peopleselectedAccess, setPeopleSelectedAccess] = useState(
    peopleWithAccess[0]
  );

  const [statuses] = useState(["Draft", "Completed", "Sent to Skatteverket"]);
  const [productDialog, setProductDialog] = useState(false);
  const [deleteProductDialog, setDeleteProductDialog] = useState(false);
  const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
  const [product, setProduct] = useState(emptyProduct);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [sharingDisabled, setSharingDisabled] = useState(false);
  const [editAccessDropdownValue, setEditAccessDropdownValue] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const [shareProductDialog, setShareProductDialog] = useState(false);
  const [sideBarOpenState, setSideBarOpenState] = useState(true);
  const [dashboardAPIResponse, setDashboardAPIResponse] = useState("");
  const [addEmailId, setAddEmailId] = useState("");
  const [addedEmailIdCount, setAddedEmailIdCount] = useState(0);
  const [selectedRowData, setSelectedRowData] = useState("");
  const [reRender, setReRender] = useState(false);
  const [shareEmailFocus, setShareEmailFocus] = useState(false);
  const [shareEmailDialogOverlap, setShareEmailDialogOverlap] = useState(true);
  const [isEmailIdAlreadyExists, setIsEmailIdAlreadyExists] = useState(false);
  const [linkSharedMessage, setLinkSharedMessage] = useState("");
  const [companyMembers, setCompanyMembers] = useState([]);
  const [accessValueRadio, setAccessValueRadio] = useState("");
  const op = useRef(null);
  const incomedeclaration2SRU = "/income-declaration-2/";
  const annualReport = "/annualreport/";
  let splittedUrl = window.location.href.split("/");
  let currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];

  const [checked, setChecked] = useState(true);

  const options = [
    TranslationFile.dashboardMyReportsBtn[userSelectedLanguage],
    TranslationFile.SharedWithMeText[userSelectedLanguage]
  ];
  const [value, setValue] = useState(options[0]);

  const [filters, setFilters] = useState({
    companyName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
    },
    organizationNumber: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
    },
    financialYear: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
    },
    createdOn: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
    },
    createdBy: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
    },
    modifiedOn: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
    },
    modifiedBy: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
    },
    status: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }]
    },
    date: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
    }
  });
  const [inputFields, setInputFields] = useState([
    {
      fullName: "",
      fullNameDp: shareAccess && shareAccess[2].name
    }
  ]);

  const [inputdata, setInputDate] = useState({
    emailId: "",
    accessLevel: shareAccess && shareAccess[2].name
  });
  const [inputarr, setInputarr] = useState([]);
  const [selectedAccess, setSelectedAccess] = useState([
    {
      fullNameDp: shareAccess && shareAccess[2].name
    }
  ]);

  //FOCUS
  const [emailIdFocus, setEmailIdFocus] = useState(false);
  const [isValidEmailId, setIsValidEmailId] = useState(false);
  const loginReducer = useSelector((state) => state.login);
  const sidebarReducer = useSelector((state) => state.sidebarReducer);
  let isAccCompany =
    loginReducer.login.values &&
    loginReducer.login.values.accountingCompany != null &&
    loginReducer.login.values.accountingCompany != undefined
      ? loginReducer.login.values.accountingCompany
      : false;
  const [activeIndex, setActiveIndex] = useState(isAccCompany ? 0 : 1);

  useEffect(() => {
    localStorage.setItem("currentPageName", "Dashboard");
    window.scrollTo(0, 0);
    let localData = localStorage.getItem("rebelSkoolUser");
    let localObject = localData && JSON.parse(localData);
    loginReducer.login.values = localObject;

    userSessionAuthKeyReturnValue = setUserSessionAuthKey();

    if (
      loginReducer.login.values != undefined &&
      userSessionAuthKeyReturnValue &&
      localObject.userID != undefined
    ) {
      axios
        .get("/SRUDashboard/getDashboardList", userSessionAuthKeyReturnValue)
        .then((response) => {
          let respData = response.data;

          if (respData.length == 0) {
            checkForSharedReports();
          } else {
            respData.map((i, idx) => {
              if (i.createdAtDateTime > i.modifiedAtDateTime) {
                return (i.modifiedAtDateTime = "");
              }
            });
            respData = respData.reverse();
            setDashboardAPIResponse(respData);
          }
        });
    }
  }, []);

  const isValidEmailID = (isValidEmailId) => {
    if (isValidEmailId) {
      setIsValidEmailId(true);
    } else {
      setIsValidEmailId(false);
    }
  };

  const getCustomers = (data) => {
    return [...(data || [])].map((d) => {
      d.createdOn = new Date(d.createdOn);
      return d;
    });
  };

  // const getSeverityOrg = (product, status) => {
  //   switch (status) {
  //     case "Completed":
  //       return "success";

  //     case "Draft":
  //       return "warning";

  //     case "Sent to Skatteverket":
  //       return "success";

  //     case "Paid":
  //       return "success";
  //     default:
  //       return null;
  //   }
  // };

  const getSeverity = (status) => {
    let statusValue = "Draft";
    if (status) {
      statusValue = "Sent to Skatteverket";
    }

    switch (statusValue) {
      case "Completed":
        return "success";

      case "Draft":
        return "warning";

      case "Sent to Skatteverket":
        return "success";
    }
  };

  const hideDialog = () => {
    setSubmitted(false);
    setProductDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProductDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteProductsDialog(false);
  };

  const confirmDeleteProduct = (product) => {
    setProduct(product);
    setDeleteProductDialog(true);
  };

  const confirmDeleteSelected = () => {
    setDeleteProductsDialog(true);
  };

  const deleteProduct = () => {
    setDeleteProductDialog(false);
    setProduct(emptyProduct);
    toast.current.show({
      severity: "success",
      summary: TranslationFile.SuccessfulText[userSelectedLanguage],
      detail: TranslationFile.ProductDeleted[userSelectedLanguage],
      life: 3000
    });
  };

  const deleteSelectedProducts = () => {
    if (userSessionAuthKeyReturnValue) {
      let reportIds = "";
      selectedProducts.length &&
        selectedProducts.map((i, idx) => {
          if (reportIds == "") reportIds = i.reportId;
          else reportIds = reportIds + "," + i.reportId;
        });

      axios
        .get(
          "/SRUHeader/hideReportHeaders?reportIds=" + reportIds,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          axios
            .get(
              "/SRUDashboard/getDashboardList",
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              let respData = response.data;
              if (respData.length == 0) {
                checkForSharedReports();
              } else {
                respData.map((i, idx) => {
                  if (i.createdAtDateTime > i.modifiedAtDateTime) {
                    return (i.modifiedAtDateTime = "");
                  }
                });
                respData = respData.reverse();
                setDashboardAPIResponse(respData);
              }
            });
        });

      setDeleteProductsDialog(false);
      setSelectedProducts(null);
      toast.current.show({
        severity: "success",
        summary: TranslationFile.SuccessfulText[userSelectedLanguage],
        detail: TranslationFile.ReportDeletedSuces[userSelectedLanguage],
        life: 3000
      });
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <div>
        {value == options[0] && (
          <Button
            className="SRU-whole-delete"
            label={TranslationFile.dashboardDeleteBtn[userSelectedLanguage]}
            icon="pi pi-trash"
            severity="danger"
            onClick={confirmDeleteSelected}
            disabled={!selectedProducts || !selectedProducts.length}
          />
        )}
      </div>
    );
  };

  const confirmShareProduct = (product) => {
    setProduct(product);
    setShareProductDialog(true);
  };

  const hideShareProductDialog = () => {
    setInputFields([
      {
        fullName: "",
        fullNameDp: shareAccess && shareAccess[2].name
      }
    ]);
    setShareProductDialog(false);
    if (isAccCompany) {
      setActiveIndex(0);
    } else {
      setActiveIndex(1);
    }
  };

  const header = () => {
    return (
      <div>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder={
              TranslationFile.dashboardSearchBtn[userSelectedLanguage]
            }
            className="SRU-dashboard-search-bar"
          />
        </span>
      </div>
    );
  };

  const dashboardTabOnChange = (e) => {
    if (userSessionAuthKeyReturnValue) {
      if (null == e) {
        setValue(value);
      } else {
        setValue(e);
      }
      if (e == options[0]) {
        axios
          .get("/SRUDashboard/getDashboardList", userSessionAuthKeyReturnValue)
          .then((response) => {
            let respData = response.data;
            respData.map((i, idx) => {
              if (i.createdAtDateTime > i.modifiedAtDateTime) {
                return (i.modifiedAtDateTime = "");
              }
            });
            respData = respData.reverse();
            setDashboardAPIResponse(respData);
          });
      }

      if (e == options[1]) {
        axios
          .get(
            "/SRUDashboard/getSharedReportsForDashboard",
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            let respData = response.data;
            respData.map((i, idx) => {
              if (i.createdAtDateTime > i.modifiedAtDateTime) {
                return (i.modifiedAtDateTime = "");
              }
            });
            respData = respData.reverse();
            setDashboardAPIResponse(respData);
          });
      }
    }
  };

  const checkForSharedReports = () => {
    axios
      .get(
        "/SRUDashboard/getSharedReportsForDashboard",
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        let respData = response.data;
        if (respData.length > 0) {
          dashboardTabOnChange(
            TranslationFile.dashboardSharedBtn[userSelectedLanguage]
          );
        } else {
          dashboardTabOnChange(
            TranslationFile.dashboardMyReportsBtn[userSelectedLanguage]
          );
        }
      });
  };

  const dashboardMyReports = () => {
    return (
      <div className="dashboard-togglebtn">
        <SelectButton
          value={value}
          onChange={(e) => dashboardTabOnChange(e.value)}
          options={options}
          className="SRU-my-reports-select-button-dashboard"
        />
      </div>
    );
  };

  const onChangeShareAccess = (e, Idx, rowData) => {
    if (userSessionAuthKeyReturnValue) {
      setSelectedAccess(e.value);

      let updateCompanySharingFieldReq = {
        reportId: rowData.reportId,
        accountingCompanySharing: e.value.name,
        modifiedBy: loginReducer.login.values.userID
      };

      axios
        .post(
          "/accountingCompany/updateHeaderReportSharing",
          updateCompanySharingFieldReq,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          axios
            .get(
              "/SRUDashboard/getDashboardList",
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              let respData = response.data;
              respData.map((i, idx) => {
                if (i.createdAtDateTime > i.modifiedAtDateTime) {
                  return (i.modifiedAtDateTime = "");
                }
              });
              respData = respData.reverse();
              setDashboardAPIResponse(respData);

              let shareReportWithinCompanyReq = {
                reportId: rowData.reportId,
                // userId: loginReducer.login.values.userID,
                userAccessLevel: e.value.name
              };

              axios
                .post(
                  "/SRUHeader/saveReportAccess",
                  shareReportWithinCompanyReq,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {
                  axios
                    .get(
                      "/SRUDashboard/getDashboardList",
                      userSessionAuthKeyReturnValue
                    )
                    .then((response) => {
                      let respData = response.data;
                      respData.map((i, idx) => {
                        if (i.createdAtDateTime > i.modifiedAtDateTime) {
                          return (i.modifiedAtDateTime = "");
                        }
                      });
                      respData = respData.reverse();
                      setDashboardAPIResponse(respData);
                    });
                });
            });
        });
    }
  };

  const linkShareOnClick = (rowData) => {
    accRegNo = loginReducer.login.values.accountingCompanyRegNo;
    let localData = localStorage.getItem("rebelSkoolUser");
    let localObject = JSON.parse(localData);

    setSelectedRowData(rowData);
    setInputarr([]);
    let responseObj = {
      emailId: "",
      accessLevel: ""
    };
    let arr = [];

    let lastIdx = 0;

    if (
      !loginReducer.login.values.accountingCompany ||
      !localObject.accountingCompany
    ) {
      if (userSessionAuthKeyReturnValue) {
        axios
          .get(
            "/SRUDashboard/getUserDetailsAndAccessOfReports?reportId=" +
              rowData.reportId,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            let responseData = response.data;
            responseData &&
              responseData.length &&
              responseData.map((i, idx) => {
                lastIdx = idx;
                // let accessLevelObj = {
                //   name: i.accessLevel,
                //   code: i.accessLevel
                // };

                let responseObj = {
                  emailId: i.emailId,
                  accessLevel: i.accessLevel,
                  reportId: rowData.reportId
                };

                let { emailId, accessLevel } = i;

                responseObj.emailId = i.emailId;
                responseObj.accessLevel = i.accessLevel;
                arr.push(responseObj);

                // setInputarr((inputarr) => [...inputarr, responseObj]);
                setInputarr((inputarr) => [
                  ...inputarr.filter((val) => val.emailId != ""),
                  responseObj
                ]);
              });
            setShareProductDialog(true);
          });
      }
    } else {
      //Accounting User
      if (userSessionAuthKeyReturnValue) {
        //The below API will return the accounting company details and the users/Admin under the accounting company
        axios
          .get(
            "/accountingCompany/getCompanyDetailsAndUsers?accountingCompanyId=" +
              accRegNo,
            userSessionAuthKeyReturnValue
          )
          .then((res) => {
            let resData = res.data.usersResponse;
            // setCompanyMembers(resData)
            resData = resData.filter(
              (val) =>
                val.emailID != localObject.emailID && val.status != "In Active"
            );
            setCompanyMembers(resData);
            //This API will get you the access people of the report
            axios
              .get(
                "/SRUDashboard/getUserDetailsAndAccessOfReports?reportId=" +
                  rowData.reportId,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                let responseData = response.data;
                //Step 1: Seperate the external & Internal users
                //In the internal Users, find the person who has accountingCompanyRegNo and accoutingCompanyID
                let internalUsers = responseData.filter(
                  (val) =>
                    val.accountingCompanyRegNo != null &&
                    val.accoutingCompanyID > 0 &&
                    val.accountingCompanyRegNo == accRegNo
                );

                //Merge the resData and internal Users
                //Need firstName, lastName, emailID from resData
                let userData = resData.map((val) => {
                  return {
                    firstName: val.firstName,
                    lastName: val.lastName,
                    emailId: val.emailID
                  };
                });
                let mergedSet = userData.map((itemA) => {
                  let matchingItemB = internalUsers.find(
                    (itemB) => itemB.emailId === itemA.emailId
                  );
                  return { ...itemA, ...matchingItemB };
                });

                mergedSet &&
                  mergedSet.length &&
                  mergedSet.map((i, idx) => {
                    lastIdx = idx;
                    // let accessLevelObj = {
                    //   name: i.accessLevel,
                    //   code: i.accessLevel
                    // };
                    let responseObj = {
                      emailId: i.emailId,
                      accessLevel: i.accessLevel,
                      firstName: i.firstName,
                      lastName: i.lastName,
                      reportId: rowData.reportId
                    };

                    let { emailId, accessLevel } = i;

                    responseObj.emailId = i.emailId;
                    responseObj.accessLevel = i.accessLevel;
                    responseObj.firstName = i.firstName;
                    responseObj.lastName = i.lastName;
                    arr.push(responseObj);

                    //Set the merged variable in companyMembers state
                  });
                setCompanyMembers(arr);
                //The accoutingCompanyID should be equal to the Report Owner, If not, the person will be considered as an external User
                //Set the external Users in inputarr state
                let externalUsers = responseData.filter(
                  (val) =>
                    !internalUsers.some(
                      (valObj) => valObj.emailId == val.emailId
                    )
                );
                externalUsers &&
                  externalUsers.length &&
                  externalUsers.map((i, idx) => {
                    lastIdx = idx;
                    // let accessLevelObj = {
                    //   name: i.accessLevel,
                    //   code: i.accessLevel
                    // };
                    let responseObj = {
                      emailId: i.emailId,
                      accessLevel: i.accessLevel,
                      reportId: rowData.reportId
                    };

                    let { emailId, accessLevel } = i;

                    responseObj.emailId = i.emailId;
                    responseObj.accessLevel = i.accessLevel;

                    setInputarr((inputarr) => [
                      ...inputarr.filter((val) => val.emailId != ""),
                      responseObj
                    ]);
                  });
              });
          });
      }
    }
    setShareProductDialog(true);
  };

  const linkSharingBodyTemplate = (rowData) => {
    return (
      <div
        style={{ cursor: "pointer" }}
        onClick={() => linkShareOnClick(rowData)}
      >
        {rowData.sharedToNoOfUsers > 0 ? (
          <a className="dashboard-link-share-pop-up">
            {rowData.sharedToNoOfUsers + " user"}
          </a>
        ) : (
          <Button icon="pi pi-share-alt" />
        )}
      </div>
    );
  };

  const shareAccessBodyTemplate = (rowData, Idx) => {
    const obj = [
      {
        name: rowData.accountingCompanySharing,
        code: rowData.accountingCompanySharing
      }
    ];

    return (
      <React.Fragment>
        <Dropdown
          value={obj[0]}
          onChange={(e) => onChangeShareAccess(e, Idx.rowIndex, rowData)}
          options={shareAccess}
          optionLabel="name"
          className="w-full md:w-14rem sru-share-access"
          dropdownIcon={
            <RiArrowDownSFill className="drop-down-black-fill-icon" />
          }
        />
      </React.Fragment>
    );
  };

  const companyNameBodyTemplate = (rowData) => {
    const companyNameOnClick = (rowData) => {
      localStorage.setItem("navigateTo", "SRU CompanyInformation");
      localStorage.setItem("navigateToGUID", rowData.reportGUID);
      localStorage.setItem("navigatedCompanyName", rowData.companyName);
    };

    return (
      <a
        className="SRU-dashbaord-companyName"
        href={`/income-declaration-2/${rowData.reportGUID}/companyInfo`}
        onClick={(e) => {
          e.preventDefault();
          companyNameOnClick(rowData);
          window.location.href = `/income-declaration-2/${rowData.reportGUID}/companyInfo`;
        }}
      >
        {rowData.companyName}
      </a>
    );
  };

  // const companyNameBodyTemplate = (rowData) => {
  //   return (
  //     <a
  //       className="SRU-dashbaord-companyName"
  //       onClick={() => companyNameOnClick(rowData)}
  //     >
  //       {rowData.companyName}
  //     </a>
  //   );
  // };

  // const companyNameOnClick = (rowData) => {
  //   localStorage.setItem("navigateTo", "SRU CompanyInformation");
  //   localStorage.setItem("navigateToGUID", rowData.reportGUID);
  //   localStorage.setItem("navigatedCompanyName", rowData.companyName);

  //   const incomedeclaration2SRU = "/income-declaration-2/";
  //   history.push(incomedeclaration2SRU + rowData.reportGUID + "/companyInfo");
  //   window.location.reload(false);
  // };

  const statusBodyTemplate = (rowData) => {
    const status = rowData?.reportStatus || "Draft";

    return (
      <Tag
        value={status}
        style={{
          backgroundColor: reportStatusColourCode(status)?.[0],
          color: reportStatusColourCode(status)?.[1]
        }}
      />
    );
  };

  // const paymentStatusBody = (rowData) => {
  //   let status;
  //   if (rowData.paymentEntryNo > 0) {
  //     status = "Paid";

  //     return (
  //       <Tag value={status} severity={getSeverityOrg(rowData, status)}></Tag>
  //     );
  //   }
  // };

  const statusBodyTemplateTEST = (rowData) => {
    return getStatusLabelTEST(rowData.accountingCompanySharing);
  };

  const getStatusLabelTEST = (status) => {
    switch (status) {
      case "Read Only":
        return "Read Only";

      case "Write":
        return "Write";

      case "-":
        return "-";
    }
  };

  const reportStatusColourCode = (status) => {
    switch (status) {
      case "Sent to Skatteverket":
      case "Skickat till Skatteverket":
        return ["#2196F3", "#ffffff"];

      case "Action Required":
      case "Åtgärd krävs":
        return ["#efff009e", "#000000"];

      case "Registered":
      case "Registrerad":
        return ["#689F38", "#ffffff"];

      case "Closed (Not Registered)":
      case "Avslutad (Ej registrerad)":
        return ["#80808038", "#000000"];

      case "Technical Error":
      case "Tekniskt fel":
        return ["#D32F2F", "#ffffff"];

      case "Draft":
      case "Utkast":
        return ["#FBC02D", "#ffffff"];

      case "Completed":
        return ["#689F38", "#ffffff"];

      default:
        return ["#808080", "#ffffff"];
    }
  };

  const onRowEditCompleteOutside = (e) => {
    let { newData, index } = e;
    let tempOutside = [];
    let requestStr = {
      reportId: selectedRowData.reportId,
      createdByUserId: loginReducer && loginReducer.login.values.userID,
      userAccessLevel: editAccessDropdownValue.code,
      emailId: newData.emailId,
      isUpdate: true
    };

    axios
      .post(
        "/SRUHeader/saveReportAccess",
        requestStr,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        if (response.data) {
          toast.current.show({
            severity: "success",
            summary: TranslationFile.SuccessfulText[userSelectedLanguage],
            detail: TranslationFile.ReportSharedSuces[userSelectedLanguage],
            life: 3000
          });

          tempOutside = inputarr;
          tempOutside &&
            tempOutside.map((val) => {
              if (newData.emailId == val.emailId) {
                return (val.accessLevel = newData.accessLevel);
              }
            });
          tempOutside.length > 0 &&
            tempOutside.map((val) => {
              setInputarr((inputarr) => [
                ...inputarr.filter((val) => val.emailId != "")
              ]);
            });

          const encodedEmail = encodeURIComponent(newData.emailId);

          axios
            .get(
              "/user/getByEmail?emailId=" + encodedEmail,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              let userData = response.data;
              let sendMailObject = {
                recipient: newData.emailId,
                emailType: "reportShareSRU",
                userGUID: userData.userGUID,
                reportGuid: selectedRowData.reportGUID,
                noOfAttempts: 0,
                status: "New",
                userName: localObject.emailID,
                message: ""
              };

              const url = "/emailQueueController/insertEmailQueueAndSendMail";
              const formData = new FormData();
              const objString = JSON.stringify(sendMailObject);

              formData.append("request", objString);
              const config = {
                headers: {
                  timeZone: userTimeZone,
                  "User-Session-Auth-Key":
                    userSessionAuthKeyReturnValue.headers[
                      "User-Session-Auth-Key"
                    ],
                  language: userSelectedLanguage
                }
              };

              axios.post(url, formData, config).then((response) => {
                if (response.data) {
                }
              });
            });
        }
      });
    setReRender(true);
  };
  const onRowEditComplete = (e) => {
    let { newData, index } = e;
    let temp = [];

    let requestStr = {
      reportId: newData.reportId,
      createdByUserId: loginReducer && loginReducer.login.values.userID,
      userAccessLevel:
        getAccessLevelTextInEn(newData.accessLevel) == undefined
          ? newData.accessLevel
          : getAccessLevelTextInEn(newData.accessLevel),
      emailId: newData.emailId,
      isUpdate: true
    };

    axios
      .post(
        "/SRUHeader/saveReportAccess",
        requestStr,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        if (response.data) {
          toast.current.show({
            severity: "success",
            summary: TranslationFile.SuccessfulText[userSelectedLanguage],
            detail: TranslationFile.ReportSharedSuces[userSelectedLanguage],
            life: 3000
          });
          temp = companyMembers;
          temp.map((val) => {
            if (newData.emailId == val.emailId) {
              return (val.accessLevel = newData.accessLevel);
            }
          });
          temp &&
            temp.map((val) => {
              setCompanyMembers((companyMembers) => [...companyMembers]);
            });
          if (companyMembers && companyMembers.length > 0) {
            setActiveIndex(0);
          } else {
            setActiveIndex(1);
          }
          //Send Email
          const encodedEmail = encodeURIComponent(newData.emailId);

          axios
            .get(
              "/user/getByEmail?emailId=" + encodedEmail,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              let userData = response.data;
              let sendMailObject = {
                recipient: newData.emailId,
                emailType: "reportShareSRU",
                userGUID: userData.userGUID,
                reportGuid: selectedRowData.reportGUID,
                noOfAttempts: 0,
                status: "New",
                userName: localObject.emailID,
                message: ""
              };

              const url = "/emailQueueController/insertEmailQueueAndSendMail";
              const formData = new FormData();
              const objString = JSON.stringify(sendMailObject);

              formData.append("request", objString);
              const config = {
                headers: {
                  timeZone: userTimeZone,
                  "User-Session-Auth-Key":
                    userSessionAuthKeyReturnValue.headers[
                      "User-Session-Auth-Key"
                    ],
                  language: userSelectedLanguage
                }
              };

              axios.post(url, formData, config).then((response) => {
                if (response.data) {
                }
              });
            });
        }
      });
    setReRender(true);
  };
  const statusItemTemplate = (option) => {
    return <Tag value={option} severity={getSeverity(option)} />;
  };

  const statusFilterTemplate = (options) => {
    return (
      <div className="TEST">
        <Dropdown
          value={options.value}
          options={statuses}
          onChange={(e) => options.filterCallback(e.value, options.index)}
          itemTemplate={statusItemTemplate}
          placeholder={TranslationFile.dashboardSelectOne[userSelectedLanguage]}
          className="dashboard-status-filter"
          showClear
          filter={false}
        />
      </div>
    );
  };
  const accessLevelItemTemplate = (option) => {
    return <Tag value={option} severity={getSeverityActive(option)} />;
  };
  const accessLevelFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={shareAccess}
        optionLabel="label"
        optionValue="code"
        onChange={(e) => {
          options.filterCallback(e.value, options.index);
        }}
        placeholder={TranslationFile.dashboardSelectOne[userSelectedLanguage]}
        className="dashboard-status-filter"
        showClear
        filter={false}
      />
    );
  };

  const navigateToPdf = (reportGUID) => {
    window.open(`#/annualreport/${reportGUID}/pdf`, "_blank");
  };

  const pdfBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          type="button"
          icon="pi pi-file-pdf"
          className="SRU_pdf-icon"
          tooltip="PDF"
          tooltipOptions={{ position: "bottom" }}
          // onClick={() => navigateToPdf(rowData)}
          onClick={() => previewPdf(rowData.reportGUID)}
        />
      </React.Fragment>
    );
  };

  const sruBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          type="button"
          icon="pi pi-download"
          className="SRU_download-icon"
          tooltip={"Download\n(INFO.SRU + BLANKETTER.SRU)"}
          tooltipOptions={{
            position: "bottom",
            className: "sru-download-tooltip"
          }}
          onClick={() => downloadSRUFile(rowData.reportId, toast)}
        />
      </React.Fragment>
    );
  };

  const showCopyLinkSuccess = () => {
    toast.current.show({
      severity: "info",
      summary: TranslationFile.SuccessText[userSelectedLanguage],
      detail: TranslationFile.Linkcopied[userSelectedLanguage],
      life: 5000
    });
  };

  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label={TranslationFile.noBtn[userSelectedLanguage]}
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label={TranslationFile.yesBtn[userSelectedLanguage]}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );

  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label={TranslationFile.noBtn[userSelectedLanguage]}
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label={TranslationFile.yesBtn[userSelectedLanguage]}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  const shareProductDialogFooter = () => {
    const linkToCopy =
      config.SRU.url + "/" + selectedRowData.reportGUID + "/companyInfo";
    return (
      <div>
        <div className="share-dialog-note">
          {isAccCompany && activeIndex === 0 ? (
            <span className="share-dialog-note">
              <strong>📝 Note:</strong> "Inside the Organisation" includes all
              people who belong to your organisation.
            </span>
          ) : (
            <span className="share-dialog-note">
              <strong>📝 Note:</strong> "Outside the Organisation" allows you to
              share the link with people outside your organisation.
            </span>
          )}
        </div>
        <React.Fragment>
          <CopyToClipboard text={linkToCopy}>
            <Button
              label={TranslationFile.dashboardCopyLinkBtn[userSelectedLanguage]}
              onClick={showCopyLinkSuccess}
              outlined
              id="copy-link-button-id"
            />
          </CopyToClipboard>
          <Button
            label={TranslationFile.dashboardDoneBtn[userSelectedLanguage]}
            icon="pi pi-check"
            severity="info"
            // onClick={(e) => addInputField(e)}
            onClick={() => emailIDTabOutFunction()}
            disabled={inputdata.emailId == "" && true}
          />
        </React.Fragment>
      </div>
    );
  };

  const [emailArray, setEmailArray] = useState([]);
  const sideBarStatus = (e) => {
    setSideBarOpenState(e);
  };

  const changeAccessForPeopleEmail = (e) => {
    setPeopleSelectedAccess(e.value);
  };

  const getUserShareEmail = (e) => {
    setShareEmail(e.target.value);
  };
  const changeAccessForEmail = (e) => {
    setSelectedAccess(e.value);
  };

  let localData = localStorage.getItem("rebelSkoolUser");
  let localObject = JSON.parse(localData);

  const addTableRows = () => {
    const rowsInput = {
      fullName: "",
      fullNameDp: shareAccess && shareAccess[2].name
    };
    setInputFields([...inputFields, rowsInput]);
  };

  const addInputField = (e) => {
    if (
      inputFields[inputFields.length - 1].fullName !== "" &&
      userSessionAuthKeyReturnValue
    ) {
      let requestStr = {
        reportId: selectedRowData.reportId,
        createdByUserId: loginReducer.login.values.userID,
        userAccessLevel: inputFields[inputFields.length - 1].fullNameDp.name,
        emailId: inputFields[inputFields.length - 1].fullName,
        isInsert: true
      };

      if (loginReducer.login.values.emailID != requestStr.emailId) {
        axios
          .post(
            "/SRUHeader/saveReportAccess",
            requestStr,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: TranslationFile.SuccessfulText[userSelectedLanguage],
              detail: TranslationFile.ReportSharedSuces[userSelectedLanguage],
              life: 3000
            });
            axios
              .get(
                "/SRUDashboard/getDashboardList",
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                let respData = response.data;
                respData.map((i, idx) => {
                  if (i.createdAtDateTime > i.modifiedAtDateTime) {
                    return (i.modifiedAtDateTime = "");
                  }
                });
                respData = respData.reverse();
                setDashboardAPIResponse(respData);
              });
          });
      } else {
        toast.current.show({
          severity: "error",
          summary: TranslationFile.errorText[userSelectedLanguage],
          detail: TranslationFile.CantShareReportText[userSelectedLanguage],
          life: 3000
        });
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setInputarr([...inputarr, { emailId, accessLevel }]);
  }, []);

  const inputEmailIDOnBlur = (e) => {
    let localData = localStorage.getItem("rebelSkoolUser");
    let localObject = JSON.parse(localData);
    if (inputdata.emailId != "") {
      if (inputdata.emailId == localObject.emailID) {
        toast.current.show({
          severity: "warn",
          summary: "No Sharing Applicable",
          detail: "The Report can't be shared to the Report Creator's Mail",
          life: 4000
        });
        setInputDate({ emailId: "", accessLevel: "" });

        setSharingDisabled(true);
      } else {
        setSharingDisabled(false);
      }

      if (inputdata.emailId !== localObject.emailID) {
        //Check this email id is already has access to the report
        //If it has show a toast message and clear the value in the input box
        let sameEmailId = inputarr.filter(
          (val) => val.emailId == inputdata.emailId
        );
        if (sameEmailId.length > 0) {
          toast.current.show({
            severity: "error",
            summary: "Report Already Shared",
            detail: "The Report is already being shared to the user",
            life: 4000
          });
          setInputDate({ emailId: "", accessLevel: "" });

          setSharingDisabled(true);
        }
      } else {
        setSharingDisabled(false);
      }

      //
    }
    //TODO Find Out whether the report has been shared with the emailID already
  };
  const accessEditor = (options) => {
    let value = options.value == undefined ? "" : options.value;
    let dropdownValue = "";

    if (userSelectedLanguage == "sw") {
      dropdownValue = getAccessLevelTextInSw(value);
    } else if (userSelectedLanguage == "en") {
      dropdownValue = getAccessLevelTextInEn(value);
    }

    if (dropdownValue == undefined) {
      dropdownValue = value;
    }

    // if (dropdownValue.code == undefined || dropdownValue.name == undefined) {
    //   dropdownValue = "";
    // }

    return (
      <Dropdown
        value={dropdownValue}
        options={shareAccess}
        onChange={(e) => {
          options.editorCallback(e.value.label);
          setEditAccessDropdownValue(e.value);
        }}
        placeholder={dropdownValue}
      />
    );
  };

  function changeHandle(e, field) {
    if (field == "email") {
      setInputDate({ ...inputdata, [e.target.name]: e.target.value });
    } else {
      setInputDate({ ...inputdata, [e.target.name]: e.target.value });
    }
  }
  let { emailId, accessLevel } = inputdata;

  const addInputFieldNew = (e) => {
    if (inputdata.emailId != "" && userSessionAuthKeyReturnValue) {
      let req = {
        reportId: selectedRowData.reportId,
        createdByUserId: loginReducer.login.values.userID,
        userAccessLevel: inputdata.accessLevel.name,
        emailId: inputdata.emailId,
        isInsert: true
      };

      if (!validateEmail(inputdata.emailId)) {
        isValidEmailIDCheck = false;
      } else {
        isValidEmailIDCheck = true;
        setInputarr([...inputarr, { emailId, accessLevel }]);

        setInputDate({ emailId: "" });

        axios
          .post(
            "/SRUHeader/saveReportAccess",
            req,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            if (response.data) {
              toast.current.show({
                severity: "success",
                summary: TranslationFile.SuccessfulText[userSelectedLanguage],
                detail: TranslationFile.ReportSharedSuces[userSelectedLanguage],
                life: 3000
              });
              setTimeout(() => {
                hideShareProductDialog();
              }, 1000);

              axios
                .get(
                  "/SRUDashboard/getDashboardList",
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {
                  let respData = response.data;
                  respData &&
                    respData.length &&
                    respData.map((i, idx) => {
                      if (i.createdAtDateTime > i.modifiedAtDateTime) {
                        return (i.modifiedAtDateTime = "");
                      }
                    });
                  respData = respData.reverse();
                  setDashboardAPIResponse(respData);
                });
              const encodedEmail = encodeURIComponent(req.emailId);

              axios
                .get(
                  "/user/getByEmail?emailId=" + encodedEmail,
                  userSessionAuthKeyReturnValue
                )
                .then((userDetailsByEmailIdResp) => {
                  let userDetailsByEmailIdRespData =
                    userDetailsByEmailIdResp.data;
                  if (userDetailsByEmailIdRespData.userID > 0) {
                    let sendMailObject = {
                      recipient: inputdata.emailId,
                      emailType: "reportShareSRU",
                      userGUID: userDetailsByEmailIdRespData.userGUID,
                      reportGuid: selectedRowData.reportGUID,
                      noOfAttempts: 0,
                      status: "New",
                      userName: localObject.emailID,
                      message: linkSharedMessage
                    };

                    const url =
                      "/emailQueueController/insertEmailQueueAndSendMail";
                    const formData = new FormData();
                    const objString = JSON.stringify(sendMailObject);

                    formData.append("request", objString);
                    const config = {
                      headers: {
                        timeZone: userTimeZone,
                        "User-Session-Auth-Key":
                          userSessionAuthKeyReturnValue.headers[
                            "User-Session-Auth-Key"
                          ],
                        language: userSelectedLanguage
                      }
                    };

                    axios.post(url, formData, config).then((response) => {
                      if (response.data) {
                      }
                    });
                  }
                });
            }
          });
      }
    }
  };

  const removeInputFields = (index) => {
    const rows = [...inputFields];
    rows.splice(index, 1);
    setInputFields(rows);
  };

  const shareProductDialogFooterOverlap = (
    <React.Fragment>
      <Button
        label={TranslationFile.dashboardLinkShareBtn[userSelectedLanguage]}
        icon="pi pi-check"
        severity="success"
        onClick={addInputFieldNew}
      />
    </React.Fragment>
  );

  let isExist = false;
  function emailIDTabOutFunction() {
    let userLoginDetails = {
      emailID: inputdata.emailId
    };

    if (userLoginDetails.emailID != "") {
      if (inputarr.filter((e) => e.emailId === inputdata.emailId).length > 0) {
        isExist = true;
      }
    }

    if (!isExist) {
      return (
        <div>
          <Dialog
            className="SRU-dashboard-sharedialog"
            blockScroll
            visible={shareEmailDialogOverlap}
            header={
              TranslationFile.dashboardLinkShareHeaderText[userSelectedLanguage]
            }
            onHide={() => accessLevelDialogBox()}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            modal
            footer={shareProductDialogFooterOverlap}
          >
            <div>
              <br></br>
              <Row className="SRU-dashboard-share-overlap-row">
                <Col className="SRU-dashboard-link-email-input-box">
                  <InputText
                    type="text"
                    name="emailId"
                    value={inputdata.emailId}
                    onChange={changeHandle}
                    placeholder={
                      TranslationFile.dashboardEnterEmailId[
                        userSelectedLanguage
                      ]
                    }
                    className="SRU-dashboard-emai-id-overlap"
                  />
                </Col>

                <Col className="SRU-dashboard-link-access-dropdown">
                  <Dropdown
                    value={inputdata.accessLevel}
                    options={shareAccess}
                    optionLabel="name"
                    name="accessLevel"
                    className="SRU-dashboard-mail-give-access-dropdown"
                    onChange={changeHandle}
                    dropdownIcon={
                      <RiArrowDownSFill className="drop-down-black-fill-icon" />
                    }
                  />
                </Col>
              </Row>
              <br></br>

              <div className="SRU-dashboard-share-message">
                {" "}
                {
                  TranslationFile.dashboardLinkShareMessage[
                    userSelectedLanguage
                  ]
                }
              </div>
              <InputTextarea
                rows={4}
                cols={30}
                onChange={(e) => setLinkSharedMessage(e.target.value)}
                className="SRU-dashboard-share-annual-text-area"
              />
            </div>
          </Dialog>
        </div>
      );
    }
  }

  const accessLevelDialogBox = () => {
    setShareEmailDialogOverlap(false);
    inputdata.emailId = "";
    setInputDate({ emailId: "" });
  };
  const accessEmailBodyTemplate = (rowData) => {
    if (rowData.emailId != "") {
      return <div>{rowData.emailId}</div>;
    }
  };

  // const accessBodyTemplate = (rowData) => {
  //   if (rowData.accessLevel != undefined) {
  //     let accessLevel;
  //     if (userSelectedLanguage == "sw")
  //       accessLevel = getAccessLevelTextInSw(rowData["accessLevel"]);
  //     else accessLevel = getAccessLevelTextInEn(rowData["accessLevel"]);

  //     if (accessLevel == undefined) accessLevel = rowData["accessLevel"];

  //     return (
  //       <Tag
  //         style={{ textAlign: "center" }}
  //         value={accessLevel != undefined ? accessLevel : "NIL"}
  //         severity={getSeverityActive(accessLevel)}
  //       ></Tag>
  //     );
  //   }
  // };

  const accessBodyTemplate = (rowData) => {
    if (rowData.accessLevel != undefined) {
      const rawAccessLevel =
        typeof rowData.accessLevel === "object" && rowData.accessLevel !== null
          ? rowData.accessLevel.name
          : rowData.accessLevel;

      let accessLevel;
      if (userSelectedLanguage == "sw")
        accessLevel = getAccessLevelTextInSw(rawAccessLevel);
      else accessLevel = getAccessLevelTextInEn(rawAccessLevel);

      if (accessLevel == undefined) accessLevel = rawAccessLevel;

      return (
        <Tag
          style={{ textAlign: "center" }}
          value={accessLevel != undefined ? accessLevel : "NIL"}
          severity={getSeverityActive(accessLevel)}
        ></Tag>
      );
    }
  };
  const handleChangeNew = (index, evnt, i) => {
    if (i.emailId != "" && userSessionAuthKeyReturnValue) {
      let requestStr = {
        reportId: selectedRowData.reportId,
        createdByUserId: loginReducer.login.values.userID,
        userAccessLevel: evnt.target.value.name,
        emailId: i.emailId,
        isUpdate: true
      };

      axios
        .post(
          "/SRUHeader/saveReportAccess",
          requestStr,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          toast.current.show({
            severity: "success",
            summary: TranslationFile.SuccessfulText[userSelectedLanguage],
            detail: TranslationFile.ReportUpdatedSuces[userSelectedLanguage],
            life: 3000
          });
          axios
            .get(
              "/SRUDashboard/getDashboardList",
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              inputarr.map((arrValue, arrValueIdx) => {
                if (arrValueIdx == index) {
                  return (arrValue.accessLevel = evnt.target.value);
                }
              });
              transformedArray.map((arrValue, arrValueIdx) => {
                if (arrValueIdx == index) {
                  return (arrValue.accessLevel = evnt.target.value);
                }
              });
              let respData = response.data;
              respData.map((i, idx) => {
                if (i.createdAtDateTime > i.modifiedAtDateTime) {
                  return (i.modifiedAtDateTime = "");
                }
              });
              respData = respData.reverse();
              setDashboardAPIResponse(respData);
            });
        });
    }
  };

  const callback = (incomedeclaration2SRU, session, link, status) => {
    let sessionUUIDFromLS = localStorage.getItem("sessionUUID");
    if (status) {
      history.push(incomedeclaration2SRU + sessionUUIDFromLS + link);
    }
  };

  const navigateToNewReport = () => {
    localStorage.setItem("navigateTo", "SRU CompanyInformation");
    history.push("/income-declaration-2");
    window.location.reload(false);
  };

  const newReport = async () => {
    try {
      // localStorage.setItem("sruNavigateTo", "companyInfo");
      // localStorage.setItem("navigateToGUID", "");
      // localStorage.setItem("navigatedCompanyName", "");
      // localStorage.setItem("possibleAccessablePages", "companyInfo");

      const response = await axios.get("/cms/generateUUID");

      const newReportGUID = response.data;

      window.open(
        `/income-declaration-2/${newReportGUID}/companyInfo`,
        "_blank"
      );
    } catch (error) {
      console.error("Error generating UUID:", error);
    }
  };

  const openTheLoginSidebar = () => {
    document.getElementsByClassName("user-btn")[0].click();
  };

  const emptyMessageBodyTemplate = () => {
    if (
      localObject != undefined &&
      localObject.emailID != undefined &&
      localObject.userName != undefined
    ) {
      if (value == options[0]) {
        return (
          <div>
            {
              TranslationFile.dashboardNoReportForIncomeDeclaration2[
                userSelectedLanguage
              ]
            }{" "}
            <br></br>
            {
              TranslationFile.dashboardCreateIncomeDeclaration[
                userSelectedLanguage
              ]
            }
            <button
              onClick={() => newReport()}
              id="SRU-dashboard-new-report-dashboard"
              className="new-annual-report-create-button"
            >
              {TranslationFile.sidebarNewReport[userSelectedLanguage]}
            </button>
          </div>
        );
      } else {
        return (
          <div>
            {TranslationFile.dashboardNoSharedReport[userSelectedLanguage]}
          </div>
        );
      }
    } else {
      return (
        <div>
          {value == options[0] ? (
            <div>
              {
                TranslationFile.dashboardLoginInToViewReports[
                  userSelectedLanguage
                ]
              }
            </div>
          ) : (
            <div>
              {
                TranslationFile.dashboardLoginInToViewSharedReports[
                  userSelectedLanguage
                ]
              }
            </div>
          )}
          <br></br>
          {TranslationFile.dashboardLoginBtn[userSelectedLanguage]}
          <button
            onClick={() => openTheLoginSidebar()}
            id="SRU-dashboard-new-report-dashboard"
            className="new-annual-report-create-button"
          >
            Login
          </button>
        </div>
      );
    }
  };

  const checkSelectedReports = (e) => {
    let paidReportArray = [];
    e &&
      e.forEach((element) => {
        if (element.paymentEntryNo > 0) {
          paidReportArray.push(element);
        } else {
          unPaidReportsArray.push(element);
        }
        unPaidReportsArray = [...new Set(unPaidReportsArray)];
        setSelectedProducts(unPaidReportsArray);
        if (paidReportArray.length > 0) {
          toast.current.show({
            severity: "error",
            summary: "No Delete Applicable",
            detail: "The Paid Report cannot be deleted",
            life: 5000
          });
        }
      });
  };

  const sideBarCallback = () => {
    // StatusALert("signUp")
  };

  const downloadSRUFile = (reportId, toast) => {
    if (!reportId) {
      console.error("Report ID is missing:", reportId);
      return;
    }

    axios
      .get("/SRULines/downloadInfoSRUFile?reportID=" + reportId, {
        ...userSessionAuthKeyReturnValue,
        responseType: "blob"
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: "application/zip"
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = "INFO.SRU_BLANKETTER.SRU.zip";

        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        const status = error?.response?.status;

        if (status === 404) {
          toast.current?.show({
            severity: "info",
            summary:
              TranslationFile.emptySRUReportSummary?.[userSelectedLanguage] ||
              "Report is Empty",
            detail:
              TranslationFile.emptySRUReport?.[userSelectedLanguage] ||
              "Please go and fill in the report before downloading the SRU file.",
            life: 5000
          });

          return;
        }

        if (status === 401) {
          toast.current?.show({
            severity: "info",
            summary:
              TranslationFile.unauthorizedSRUReportSummary?.[
                userSelectedLanguage
              ] || "Unauthorized",
            detail:
              TranslationFile.unauthorizedSRUReport?.[userSelectedLanguage] ||
              "You are not authorized to download this report.",
            life: 5000
          });

          return;
        }

        console.error("SRU ZIP download failed:", error);
      });
  };

  const leftToolbarTemplatebox2 = () => {
    return (
      <div>
        <Button
          type="button"
          label={TranslationFile.sharetoAllUserText[userSelectedLanguage]}
          onClick={(e) => op.current.toggle(e)}
        />
        <OverlayPanel ref={op}>
          <div style={{ width: "200px" }}>
            <div style={{ textAlign: "end" }}>
              <i className="pi pi-times" onClick={() => op.current.hide()}></i>
            </div>
            <div className="common-share-dash">
              <RadioButton
                inputId="readOnly"
                value="Read Only"
                onChange={(e) => setAccessValueRadio(e.value)}
                checked={accessValueRadio === "Read Only"}
              />
              <label style={{ paddingLeft: "10px" }} htmlFor="readOnly">
                {TranslationFile.dashboardLinkShareRead[userSelectedLanguage]}
              </label>
            </div>
            <div className="common-share-dash">
              <RadioButton
                inputId="Can Edit"
                value="Can Edit"
                onChange={(e) => setAccessValueRadio(e.value)}
                checked={accessValueRadio === "Can Edit"}
              />
              <label style={{ paddingLeft: "10px" }} htmlFor="write">
                {TranslationFile.dashboardLinkShareWrite[userSelectedLanguage]}
              </label>
            </div>
            <div className="common-share-dash">
              <RadioButton
                inputId="noAccess"
                value="No Access"
                onChange={(e) => setAccessValueRadio(e.value)}
                checked={accessValueRadio === "No Access"}
              />
              <label style={{ paddingLeft: "10px" }} htmlFor="noAccess">
                {
                  TranslationFile.dashboardLinkShareNoAccess[
                    userSelectedLanguage
                  ]
                }
              </label>
            </div>
            <div style={{ textAlign: "center", marginTop: "10%" }}>
              <Button
                label={
                  TranslationFile.dashboardLinkShareBtn[userSelectedLanguage]
                }
                severity="success"
                icon="pi pi-check"
                autoFocus
                disabled={accessValueRadio == ""}
                onClick={shareAccessOnClick}
              />
            </div>
          </div>
        </OverlayPanel>
      </div>
    );
  };

  const shareAccessOnClick = () => {
    let reqArray = [];

    companyMembers &&
      companyMembers.forEach((value) => {
        let req = {
          reportId: value.reportId,
          createdByUserId: loginReducer && loginReducer.login.values.userID,
          userAccessLevel: accessValueRadio,
          emailId: value.emailId,
          isInsert: true
        };
        reqArray.push(req);
      });
    if (userSessionAuthKeyReturnValue) {
      axios
        .post(
          "/sruReport/saveReportAccessList",
          reqArray,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data) {
            let temp = [];
            toast.current.show({
              severity: "success",
              summary: TranslationFile.SuccessfulText[userSelectedLanguage],
              detail: TranslationFile.ReportSharedSuces[userSelectedLanguage],
              life: 3000
            });
            temp = companyMembers;
            temp.map((val) => {
              return (val.accessLevel = accessValueRadio);
            });
            temp &&
              temp.map((val) => {
                setCompanyMembers((companyMembers) => [...companyMembers]);
              });
            if (companyMembers && companyMembers.length > 0) {
              setActiveIndex(0);
            } else {
              setActiveIndex(1);
            }
          }
          setAccessValueRadio("");
          op.current.hide();
        });
    }
  };

  return (
    <div>
      <Toast
        ref={toast}
        position="top-right"
        className="SRU-dashboard-toast-top"
      />
      {/* <SRUNavBarHeader
        isAppPortal={true}
        isHomePage={false}
        callBack={callback}
      /> */}
      {/* <div className="SRU-dashboard-sidebar_div">
        <Sidebar
          children="MyDashboard"
          sideBarStatus={sideBarStatus}
          sideBarCallback={() => sideBarCallback()}
        />
      </div> */}

      <div
        className={
          sideBarOpenState
            ? "SRU-myDashboardGridSideBarOpen"
            : "SRU-myDashboardGridSideBarClose"
        }
      >
        <div>
          <Toolbar
            className="SRU-dashboard-mb-4"
            left={leftToolbarTemplate}
            center={header}
            right={dashboardMyReports}
          ></Toolbar>

          <DataTable
            ref={dt}
            value={dashboardAPIResponse}
            editMode="cell"
            selection={selectedProducts}
            // onSelectionChange={(e) => setSelectedProducts(e.value)}
            onSelectionChange={(e) => checkSelectedReports(e.value)}
            selectionMode="checkbox"
            dataKey="id"
            paginator
            rows={10}
            emptyMessage={emptyMessageBodyTemplate}
            currentPageReportTemplate={
              userSelectedLanguage === "sw"
                ? "Visar {first} till {last} av {totalRecords} poster"
                : "Showing {first} to {last} of {totalRecords} entries"
            }
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[5, 10, 25, 50]}
            globalFilter={globalFilter}
            header={header}
            selectionPageOnly
            className="SRU-dashboard-datatable1"
            style={{ padding: "0rem" }}
          >
            <Column
              selectionMode="multiple"
              exportable={false}
              className="SRU-dashboard-checkbox"
            ></Column>

            <Column
              field="companyName"
              header={
                TranslationFile.dashboardCompanyName[userSelectedLanguage]
              }
              filter
              className="SRU-dashboard-company-name"
              body={companyNameBodyTemplate}
              style={{ padding: "0rem", width: "15%" }}
            ></Column>

            <Column
              field="registrationNo"
              header={TranslationFile.dashboardOrgNumber[userSelectedLanguage]}
              className="SRU-dashboard-org-no"
              filter
              style={{ padding: "0rem", width: "9%" }}
            ></Column>
            <Column
              field="financialYear"
              header={TranslationFile.dashboardFinYear[userSelectedLanguage]}
              filter
              className="SRU-dashboard-financial-year"
              style={{ padding: "0rem", width: "14%" }}
            ></Column>

            {value == options[0] && (
              <Column
                field="linkSharing"
                header={
                  TranslationFile.dashboardLinkShare[userSelectedLanguage]
                }
                className="SRU-dashboard-link-sharing"
                filter
                filterPlaceholder="Search"
                body={linkSharingBodyTemplate}
                style={{ padding: "0rem" }}
              ></Column>
            )}

            {/* {localObject != null &&
              value == "My Reports" &&
              localObject.isAccountingCompany && (
                <Column
                  field="accountingCompanySharing"
                  header={
                    TranslationFile.dashboardCompanySharing[
                    userSelectedLanguage
                    ]
                  }
                  body={shareAccessBodyTemplate}
                  style={{ minWidth: "10rem" }}
                  filter
                  className="SRU-dashboard-share-within-company"
                ></Column>
              )} */}

            <Column
              field="createdAtDateTime"
              header={TranslationFile.dashboardCreatedOn[userSelectedLanguage]}
              filter
              className="SRU-dashboard-created-on"
              style={{ padding: "0rem" }}
            ></Column>

            <Column
              field="createdBy"
              header={TranslationFile.dashboardCreatedBy[userSelectedLanguage]}
              className="SRU-dashboard-created-by"
              filter
              style={{ padding: "0rem" }}
            ></Column>
            {/* {value == options[0] && (
              <Column
                // field="createdBy"
                header="Payment Status"
                className="SRU-dashboard-created-by"
                body={paymentStatusBody}
                filter
                style={{ padding: "0rem" }}
              ></Column>
            )} */}

            <Column
              field="modifiedAtDateTime"
              header={TranslationFile.dashboardModifiedOn[userSelectedLanguage]}
              filter
              // filterPlaceholder="YYYY-MM-DD"
              className="SRU-dashboard-modified-on"
              style={{ padding: "0rem" }}
            ></Column>
            <Column
              field="modifiedBy"
              header={TranslationFile.dashboardModifiedBy[userSelectedLanguage]}
              className="SRU-dashboard-modified-by"
              filter
              style={{ padding: "0rem" }}
            ></Column>

            {/* <Column
              field="reportStatus"
              header={TranslationFile.dashboardStatusBtn[userSelectedLanguage]}
              body={statusBodyTemplate}
              filter
              filterElement={statusFilterTemplate}
              className="SRU-dashboard-status"
              showFilterMatchModes={false}
              style={{ padding: "0rem" }}
            /> */}
            <Column
              header={TranslationFile.dashboardAccess[userSelectedLanguage]}
              field="accessLevel"
              showFilterMatchModes={false}
              disabled
              body={accessBodyTemplate}
              // editor={(options) => accessEditor(options)}
            ></Column>
            <Column
              field="reportStatus"
              header={
                TranslationFile.dashboardLastSubmittedStatus[
                  userSelectedLanguage
                ]
              }
              body={statusBodyTemplate}
              filter
              filterElement={statusFilterTemplate}
              className="SRU-dashboard-status"
              showFilterMatchModes={false}
              style={{ padding: "0rem" }}
            />

            {/* <Column
              body={pdfBodyTemplate}
              exportable={false}
              className="SRU-dashboard-pdf"
              title="Download PDF"
              style={{ padding: "0rem" }}
            ></Column> */}

            <Column
              body={sruBodyTemplate}
              header={TranslationFile.DownloadSRUfiles[userSelectedLanguage]}
              exportable={false}
              className="SRU-dashboard-pdf"
              style={{ padding: "0rem", textAlign: "center" }}
            />
          </DataTable>

          <Dialog
            visible={deleteProductDialog}
            blockScroll
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header={TranslationFile.dashboardConfirmBtn[userSelectedLanguage]}
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="SRU-dashboard-confirmation-content">
              <span>
                <span>
                  {" "}
                  {TranslationFile.dashboardDeleteText[userSelectedLanguage]}
                </span>
              </span>
            </div>
          </Dialog>

          <Dialog
            visible={deleteProductsDialog}
            blockScroll
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header={TranslationFile.dashboardConfirmBtn[userSelectedLanguage]}
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="SRU-dashboard-confirmation-content">
              <div>
                <span>
                  {TranslationFile.dashboardDeleteText[userSelectedLanguage]}
                </span>
              </div>
            </div>
          </Dialog>

          <Dialog
            blockScroll
            visible={shareProductDialog}
            footer={shareProductDialogFooter}
            onHide={() => hideShareProductDialog()}
            header={
              TranslationFile.dashboardLinkShareIncomeDeclarationHeaderText[
                userSelectedLanguage
              ]
            }
          >
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
              className="Annual_reportBox1"
            >
              {isAccCompany && (
                <TabPanel
                  header={
                    TranslationFile.Inside_My_Organization_Text[
                      userSelectedLanguage
                    ]
                  }
                  className=""
                >
                  <div>
                    {companyMembers && companyMembers.length > 0 ? (
                      <div className="reportShareDetails">
                        <div className="share_people_box">
                          <Toolbar left={leftToolbarTemplatebox2}></Toolbar>
                          <DataTable
                            editMode="row"
                            paginator
                            rows={10}
                            emptyMessage="No Users Added"
                            onRowEditComplete={onRowEditComplete}
                            value={companyMembers}
                          >
                            <Column
                              header={
                                TranslationFile.LoginFirstName[
                                  userSelectedLanguage
                                ]
                              }
                              field="firstName"
                              showFilterMatchModes={false}
                              filter
                              filterMatchMode="contains"
                              showFilterMenuOptions={false}
                              filterPlaceholder={
                                TranslationFile.LoginFirstName[
                                  userSelectedLanguage
                                ]
                              }
                              disabled
                            ></Column>
                            <Column
                              header={
                                TranslationFile.LoginLastName[
                                  userSelectedLanguage
                                ]
                              }
                              filterPlaceholder={
                                TranslationFile.LoginLastName[
                                  userSelectedLanguage
                                ]
                              }
                              field="lastName"
                              showFilterMatchModes={false}
                              filter
                              filterMatchMode="contains"
                              showFilterMenuOptions={false}
                              disabled
                            ></Column>

                            <Column
                              header={
                                TranslationFile.EmailIdText[
                                  userSelectedLanguage
                                ]
                              }
                              filterPlaceholder={
                                TranslationFile.EmailIdText[
                                  userSelectedLanguage
                                ]
                              }
                              field="emailId"
                              showFilterMatchModes={false}
                              filter
                              filterMatchMode="contains"
                              showFilterMenuOptions={false}
                              disabled
                            ></Column>

                            <Column
                              header={
                                TranslationFile.dashboardAccess[
                                  userSelectedLanguage
                                ]
                              }
                              field="accessLevel"
                              showFilterMatchModes={false}
                              disabled
                              filter
                              filterElement={accessLevelFilterTemplate}
                              filterMatchMode="contains"
                              showFilterMenuOptions={false}
                              body={accessBodyTemplate}
                              editor={(options) => accessEditor(options)}
                            ></Column>
                            <Column rowEditor></Column>
                          </DataTable>
                        </div>
                      </div>
                    ) : (
                      <div className="dash-inside-organization">
                        {/* No people in your Organization */}
                        <span>
                          {
                            TranslationFile.No_People_Org_Text[
                              userSelectedLanguage
                            ]
                          }
                        </span>
                        <p>
                          Please Navigate to Manage Company Users through the
                          Sidebar to add people to your Organization.
                        </p>
                        <Button
                          onClick={() => {
                            /*     const user = JSON.parse(
                            localStorage.getItem("rebelSkoolUser")
                          ); */
                            history.push(`./admin`);
                            // history.push(`/${user.userGUID}/admin`);
                          }}
                        >
                          Go to Manage Company Users
                        </Button>
                      </div>
                    )}
                  </div>
                </TabPanel>
              )}

              <TabPanel
                header={
                  isAccCompany
                    ? TranslationFile.Outside_My_Organization_Text[
                        userSelectedLanguage
                      ]
                    : TranslationFile.Report_Sharing_Text[userSelectedLanguage]
                }
              >
                <div className="mydashboard_div1">
                  <Card
                    title={
                      TranslationFile
                        .dashboardLinkShareIncomeDeclarationHeaderText[
                        userSelectedLanguage
                      ]
                    }
                    className="report-sharing-card"
                  >
                    <div className="share_mail_box">
                      <div className="share-overlap-row">
                        <div className="link-email-input-box">
                          <InputText
                            type="text"
                            name="emailId"
                            value={inputdata.emailId}
                            onChange={(e) => changeHandle(e, "email")}
                            onBlur={inputEmailIDOnBlur}
                            placeholder={
                              TranslationFile.dashboardEnterEmailId[
                                userSelectedLanguage
                              ]
                            }
                            className="AnnualReport-email-id-overlap"
                          />
                        </div>
                        <div className="link-access-dropdown">
                          <Dropdown
                            value={inputdata.accessLevel}
                            options={shareAccess}
                            optionLabel="label"
                            name="accessLevel"
                            className="mail-give-access-dropdown"
                            onChange={(e) => {
                              changeHandle(e, "access");
                            }}
                            dropdownIcon={
                              <RiArrowDownSFill className="drop-down-black-fill-icon" />
                            }
                            placeholder={
                              TranslationFile.dashboardSelectOne[
                                userSelectedLanguage
                              ]
                            }
                          />
                        </div>
                      </div>
                      <br></br>

                      <div className="share-message">
                        {" "}
                        {
                          TranslationFile.dashboardLinkShareMessage[
                            userSelectedLanguage
                          ]
                        }
                      </div>
                      <InputTextarea
                        rows={4}
                        cols={30}
                        onChange={(e) => setLinkSharedMessage(e.target.value)}
                        className="share-annual-text-area"
                      />
                      <center className="dashboard-share-btn">
                        <Button
                          label={
                            TranslationFile.dashboardLinkShareBtn[
                              userSelectedLanguage
                            ]
                          }
                          severity="success"
                          icon="pi pi-check"
                          onClick={addInputFieldNew}
                          disabled={sharingDisabled}
                        />
                      </center>
                    </div>
                  </Card>
                  <Card
                    title={
                      TranslationFile.dashboardLinkSharePeopleAccesText[
                        userSelectedLanguage
                      ]
                    }
                    className="dashboard-linksharing-card"
                  >
                    <div className="people-access-card">
                      <DataTable
                        editMode="row"
                        className="dashboard-linksharing-datatable"
                        size="small"
                        responsiveLayout="stack"
                        breakpoint="768px"
                        rows={10}
                        value={inputarr}
                        emptyMessage={
                          TranslationFile.emptymessage[userSelectedLanguage]
                        }
                        paginator
                        paginatorTemplate=" PrevPageLink PageLinks NextPageLink "
                        onRowEditComplete={onRowEditCompleteOutside}
                      >
                        <Column
                          header={
                            TranslationFile.EmailIdText[userSelectedLanguage]
                          }
                          body={accessEmailBodyTemplate}
                          showFilterMatchModes={false}
                        ></Column>
                        <Column
                          header={TranslationFile.Status[userSelectedLanguage]}
                          field="accessLevel"
                          showFilterMatchModes={false}
                          body={accessBodyTemplate}
                          editor={(options) => accessEditor(options)}
                        ></Column>

                        <Column rowEditor></Column>
                      </DataTable>
                    </div>
                  </Card>
                </div>
              </TabPanel>
            </TabView>
          </Dialog>
        </div>
      </div>

      <ScrolltoTop />
      {/* <Footerpage /> */}
      <Footer_contact_tab isCorpPortal={false} isHomePage={true} />
    </div>
  );
}
